import React from 'react'
import Popup from 'reactjs-popup'

function TemplateInfoPopup(props) {
    const openInfoPopup = props.open
    const closeInfoModal = props.closeInfoModal
    const template = props.selectedTemplate
    console.log("selectedTemplate", props.selectedTemplate)
return (
    <Popup
        open={openInfoPopup}
        onClose={() => closeInfoModal()}
        closeOnDocumentClick
       
    >
        <div
            style={{
                //width: '300px',
                //border: '1px solid #ccc',
                padding: '15px',
                //borderRadius: '8px',
                //boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',
                fontFamily: 'Arial, sans-serif',
            }}
        >
            <h2
                style={{
                    margin: '0',
                    fontSize: '18px',
                    color:"GrayText"                }}
            >
                Template Quick View
                <p style={{padding:"15px 10px 0px 10px",fontSize: "15px", fontWeight:"bold", color:"#343434	"}}>{template.isTemplate && template.isTemplate?"Media Template": "Template"}</p>
            </h2>
            <hr
                style={{
                    border: 'none',
                    height: '1px',
                    background: '#ccc',
                    margin: '10px 0',
                }}
            />
            <p
                style={{
                    margin: '5px 0',
                    fontSize: '14px',
                }}
            >
                <strong>Template Title:</strong> {template.label}
            </p>
            <p
                style={{
                    margin: '5px 0',
                    fontSize: '14px',
                }}
            >
                <strong>Template Name/ID:</strong>  {template.nameId}
            </p>
            <p
                style={{
                    margin: '5px 0',
                    fontSize: '14px',
                }}
            >
                <strong>Text:</strong> {template.fullText}
            </p>
            <p
                style={{
                    margin: '5px 0',
                    fontSize: '14px',
                }}
            >
                <strong>Fields:</strong>
            </p>
            <ul
                style={{
                    paddingLeft: '20px',
                    margin: '5px 0',
                    fontSize: '14px',
                }}
            >
                {template.dynamicFields ? template.dynamicFields.map((field, index) => (
                    <li key={index}>{field}</li>
                )): 
                "No dynamic fields"
                }
               
            </ul>
           
            
            
        </div>
    </Popup>
)
}

export default TemplateInfoPopup